import { Button } from "@/ds/shadcn/components/ui/button";
import { Field } from "@/ds/shadcn/components/ui/field";
import { Spinner } from "@/ds/shadcn/components/ui/spinner";
import { useFormContext } from "@/lib/form/useAppForm";
import type { FC } from "react";

export interface SubmitButtonProps {
	label: string;
	className?: string;
	variant?: "default" | "destructive" | "outline" | "secondary" | "ghost" | "link";
}

export const SubmitButton: FC<SubmitButtonProps> = props => {
	const {
		label,
		className,
		variant = "default"
	} = props;

	const form = useFormContext();

	return (
		<form.Subscribe>
			{
				({ isSubmitting, canSubmit }) => (
					<Field>
						<Button variant={variant} className={className} type="submit" disabled={isSubmitting || !canSubmit}>
							{isSubmitting ? <Spinner /> : <>{label}</>}
						</Button>
					</Field>
				)
			}
		</form.Subscribe>
	);
};
